export default __webpack_public_path__ + "0a3b51b040263cc875046b16a83d68dc.png";